// OnDocumentReady do this
(function AddWarrantyFormObserver(doc) {

    // get warranty container or exit
    const besWarrantyContainer = doc.querySelector(".bes-warranty-form");
    if (!besWarrantyContainer) return;

    // get submit button or exit
    let submitButton = besWarrantyContainer.querySelector("input[type=submit]");
    if (!submitButton) return;

    // Observer handler. If form is invalid remove 'submitted' wrapper class
    function handleFieldErrorMutation(mutationsList, observer) {
        
        // skip if not needed
        if (!besWarrantyContainer.classList.contains("submitted")) return;

        // check if any validation error exists
        mutationsList.forEach(mutation => {
            const concernedChildren 
                = Array.from(mutation.target.querySelectorAll('.field-validation-error'));
                if (mutation.target.classList.contains('field-validation-error') 
                || concernedChildren.length > 0) 
            {
                // remove class from wrapper
                if (besWarrantyContainer.classList.contains("submitted")) {
                    besWarrantyContainer.classList.remove("submitted");
                }
            }
        });
    }

    // create observer and observe wrapper
    const observer = new MutationObserver(handleFieldErrorMutation);
    observer.observe(besWarrantyContainer, { attributes: true, childList: true, subtree: true });
})(document);

/**
 * Add 'submitted' class to warranty form wrapper
 * @param {any} button the button clicked
 */
function WarrantyFormSubmitClick(button) {
    const besWarrantyContainer = document.querySelector(".bes-warranty-form");
    if (!besWarrantyContainer) return;

    // add class to wrapper to enable all other things done by CSS (loading panel, etc.)
    besWarrantyContainer.classList.add("submitted");

    // remove existing error label classes because these are trigger for "remove wrapper class"
    // they come back when the form is reloaded by ajax after submit
    const existingErrors = besWarrantyContainer.querySelectorAll(".field-validation-error");
    for (const existingError of existingErrors) {
        existingError.classList.remove("field-validation-error");
    }

    // set text to show form is sending
    button.value = button.dataset.sendingText;
}
